import { useSelector } from "react-redux"
import { useQuery } from "@tanstack/react-query"
import { RootState } from "../../store/store"
import { IErrorResponse } from "../interface"
import { API_QUIT_URL } from "../constants"
import { axios } from "../axios"


const quit = async (token: string | null) => {
  const response = await axios(API_QUIT_URL, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  })
  return response.data
}

export const useQuit = () => {
  const token = useSelector((state: RootState) => state.auth.token)

  return useQuery<void, IErrorResponse>({
    queryKey: ["quit-app"],
    queryFn: () => quit(token),
    enabled: false,
    retry: false,
  })
}